import "../styles/Toppage.css";
import GoogleMap from "../components/Googlemap";

const Toppage = () => {
  return (
    <div className="ToppageWrapper">
      <GoogleMap />
    </div>
  );
};

export default Toppage;
